.root {
	pointer-events: auto;
	margin-left: .1em;
}

.root + .root {
	margin-left: .35em;
}
